"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Aggregate = /** @class */ (function () {
    function Aggregate(aggregation, value, alias) {
        this.aggregation = aggregation;
        this.value = value;
        this.alias = alias;
    }
    Aggregate.prototype.toString = function () {
        var alias = '';
        if (this.alias) {
            alias = " AS " + escape(this.alias);
        }
        return this.aggregation + "(" + this.value + ")" + alias;
    };
    return Aggregate;
}());
exports.default = Aggregate;
